var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumericSortHover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_52299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21328 16C3.88208 16 3.61328 15.7313 3.61328 15.4V0.6C3.61328 0.268799 3.88208 0 4.21328 0C4.54448 0 4.81328 0.268799 4.81328 0.6V15.4C4.81328 15.7313 4.54448 16 4.21328 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2124 15.9999C4.05874 15.9999 3.90508 15.9415 3.78833 15.8238L0.988281 13.0239C0.753906 12.7894 0.753906 12.4094 0.988281 12.175C1.2228 11.9407 1.60278 11.9407 1.83716 12.175L4.21313 14.551L6.58911 12.175C6.82349 11.9407 7.20361 11.9407 7.43799 12.175C7.67236 12.4094 7.67236 12.7894 7.43799 13.0239L4.63794 15.8238C4.51958 15.9415 4.36592 15.9999 4.2124 15.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2149 6.40005C12.8837 6.40005 12.6149 6.13125 12.6149 5.80005V1.2H11.8148C11.4836 1.2 11.2148 0.931201 11.2148 0.6C11.2148 0.268799 11.4836 0 11.8148 0H13.2149C13.5461 0 13.8149 0.268799 13.8149 0.6V5.80005C13.8149 6.13125 13.5461 6.40005 13.2149 6.40005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8149 15.9999H11.8148C11.4836 15.9999 11.2148 15.7311 11.2148 15.3999C11.2148 15.0687 11.4836 14.7999 11.8148 14.7999H13.8149C13.9252 14.7999 14.0149 14.7103 14.0149 14.5998V13.5999H12.6149C11.8428 13.5999 11.2148 12.9719 11.2148 12.1998V10.9998C11.2148 10.2278 11.8428 9.59985 12.6149 9.59985H13.8149C14.5869 9.59985 15.2149 10.2278 15.2149 10.9998V14.5998C15.2149 15.3719 14.5869 15.9999 13.8149 15.9999ZM12.6149 10.7999C12.5045 10.7999 12.4148 10.8895 12.4148 10.9998V12.1998C12.4148 12.3103 12.5045 12.3999 12.6149 12.3999H14.0149V10.9998C14.0149 10.8895 13.9252 10.7999 13.8149 10.7999H12.6149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6149 6.39995H11.8148C11.4836 6.39995 11.2148 6.13115 11.2148 5.79995C11.2148 5.46875 11.4836 5.19995 11.8148 5.19995H14.6149C14.9461 5.19995 15.2149 5.46875 15.2149 5.79995C15.2149 6.13115 14.9461 6.39995 14.6149 6.39995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_52299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumericSortHover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/numeric-sort-hover.f218d882.svg";
export { ForwardRef as ReactComponent };